<!--
 * @Author: xuhuining
 * @Date: 2022-03-22 16:30:00
 * @LastEditors: xuhuining
 * @LastEditTime: 2022-04-22 20:38:27
 * @Description: 独家策划列表页
-->
<template>
  <div class="exclusive_panning_list">
    <span class="gobackBtn" @click.stop="goBack">
      <img src="../../../assets/images/icon/back5.png" class="backimg" alt />
    </span>
    <van-list
      class="panning_list"
      v-model="loading"
      :finished="finished"
      :error.sync="LoadError"
      error-text="请求失败，点击重新加载"
      finished-text="我们会加油更新的，么么哒~"
      @load="getPanningListLoad"
    >
      <div class="list" :style="panningList.length > 0 ?  'padding: 12px 12px 0;' : ''">
        <div class="item" v-for="(item, index) in panningList" :key="index" @click="panningListClick(item)">
          <img :src="item.coverUrl" alt />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "exclusivePanningList",
  props: {},
  data() {
    return {
      panningList: [],
      loading: false,
      finished: false,
      LoadError: false,
      panningListParams: {
        page: 1,
        size: 24
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 独家策划列表
    getPanningListLoad() {
      this.$http.get("/breedWiki/exclusivePlanning", {
          page: this.panningListParams.page,
          size: this.panningListParams.size
      }, res => {
          this.loading = false
          if (res.code == '200') {
            var data = res.data.data
            if (data == null) data = []
            this.panningList = this.panningList.concat(data)
            if (this.panningListParams.page >= Math.ceil(res.data.total / this.panningListParams.size) || Math.ceil(res.data.total / this.panningListParams.size) === 0 ) {
              this.finished = true;
            } else {
              this.panningListParams.page += 1;
            }
          } else {
            this.loading = false;
            this.LoadError = true;
          }
      }, null, 'lucky')
    },
    // 列表点击
    panningListClick(item) {
      sensors.track('xingmahui_dujiacehua_click', {
        dujiacehua_names: item.name
      })
      setTimeout(() => {
        location.href = item.contentUrl
      }, 200)
      
    }
    
  }
};
</script>
<style lang="less" scoped>
.exclusive_panning_list {
  width: 100%;
  margin-top: 12px;
  .gobackBtn {
    width: 22px;
    position: absolute;
    top: 16px;
    left: 18px;
    z-index: 1;
    img {
      width: 22px;
      height: 22px;
      position: fixed;
    }
  }
  .panning_list {
    .list {
      width: 343px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      box-sizing: border-box;
      .item {
        padding-bottom: 12px;
        img {
          width: 155px;
          height: 104px;
          display: block;
          border-radius: 8px;
        }
        span {
          padding: 4px 8px 0;
          width: 139px;
          text-align: center;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 13px;
          font-weight: bold;
          color: #333333;
          line-height: 18px;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>
